import { combineReducers } from 'redux'
import reducerRightWeb from './futures/rightWeb/reducer'
import reducerHome from './futures/home/reducer'
import reducerBid from './futures/Bid/reducer'
import reducerAccount from './futures/account/reducer'
import reducerResult from './futures/result/reducer'
import reducerEvent from './futures/event/reducer'
import reducerEventNewYear2024 from './futures/event-new-year-noel/reducer'
import reducerEventThingYan from './futures/thingyan-2025/reducer'
import reducerMiniGame from './futures/mini-game/reducer'
import reducerLoginStreakStatus from './futures/shweJourney/reducer'
import reducerShweVaultStatus from './futures/ShweVault/reducer'
import reducerNotifications from './futures/notification/reducer'
import reducerRankStatus from './futures/rank/reducer'
import reducerLoyaltyPoint from './futures/loyalty-point/reducer'
import reducerDailyPrizeStatus from './futures/daily-reward/reducer'

const rootReducers = () =>
	combineReducers({
		reducerRightWeb: reducerRightWeb,
		reducerHome: reducerHome,
		bid: reducerBid,
		reducerAccount: reducerAccount,
		reducerResult: reducerResult,
		reducerEvent,
		reducerEventNewYear2024,
		reducerEventThingYan,
		reducerMiniGame,
		reducerLoginStreakStatus,
		reducerShweVaultStatus,
		reducerNotifications,
		reducerRankStatus,
		reducerLoyaltyPoint,
		reducerDailyPrizeStatus,
	})

export default rootReducers
